import { GlobalContext } from "contexts/GlobalContext";
import { ReactNode, useContext } from "react";

export const ModalConfirmButton = (props: {
    className: string;
    confirmText: string;
    confirmBtnClass?: string;
    confirmIcon?: string;
    description: ReactNode;
    onConfirm: () => void;
    btnText: ReactNode;
    disabled?: boolean;
    showPro?: boolean;
    modalBtnDisabled?: boolean;
    title?: string;
    secondaryText?: string;
    secondaryBtnClass?: string;
    secondaryIcon?: string;
    onSecondaryConfirm?: () => void;
}) => {
    const {
        className,
        btnText,
        confirmText,
        description,
        onConfirm,
        disabled,
        confirmIcon,
        confirmBtnClass,
        showPro,
        modalBtnDisabled,
        title,
        onSecondaryConfirm,
        secondaryIcon,
        secondaryText,
        secondaryBtnClass,
    } = props;

    const { setWindowConfirm } = useContext(GlobalContext);

    return (
        <button
            type="button"
            className={className}
            disabled={disabled}
            data-bs-toggle="modal"
            data-bs-target="#window-confirm"
            onClick={() => {
                setWindowConfirm({
                    confirmDescription: description,
                    confirmText,
                    onConfirm,
                    confirmIcon,
                    confirmBtnClass,
                    showPro,
                    disabled: modalBtnDisabled,
                    title,
                    onSecondaryConfirm,
                    secondaryIcon,
                    secondaryBtnClass,
                    secondaryText,
                });
            }}
        >
            {btnText}
        </button>
    );
};
